import styled from '@emotion/styled';

const CardImageContainer = styled('div')({
  display: 'block',
  height: 'calc(100% - 9rem)',
});

export default CardImageContainer;
